import React from "react";

const usd = (n) => `$${(n || 0).toFixed(2)}`;

// Month-to-date spend vs the cap, with the 50% / 80% warning marks and the hard stop.
export default function AiSpendSummary({ u }) {
  const pct = u.cap_usd > 0 ? Math.min(100, ((u.spent_usd + u.reserved_usd) / u.cap_usd) * 100) : 100;
  const tone = u.limit_reached ? "bg-red-700" : pct >= 80 ? "bg-amber-600" : "bg-erf-gold";
  return (
    <section className="border border-erf-borderCream rounded bg-white p-4 space-y-3" data-testid="ai-spend-summary" aria-labelledby="ai-spend-title">
      <h2 id="ai-spend-title" className="font-display font-semibold">This month ({u.month})</h2>
      <p className="text-2xl font-display" data-testid="ai-spend-total">{usd(u.spent_usd)} <span className="text-base text-erf-dark/70">of {usd(u.cap_usd)} limit</span></p>
      <div className="h-3 rounded bg-erf-cream overflow-hidden" role="progressbar" aria-valuenow={Math.round(pct)} aria-valuemin={0} aria-valuemax={100}
        aria-label="Share of the monthly AI limit used" data-testid="ai-spend-bar">
        <div className={`h-full ${tone}`} style={{ width: `${pct}%` }} />
      </div>
      <p className="text-sm" data-testid="ai-spend-remaining">
        {usd(u.remaining_usd)} left{u.reserved_usd > 0 ? ` · ${usd(u.reserved_usd)} reserved by calls in progress` : ""} · warnings at {u.warn_at_usd.map(usd).join(" and ")}
      </p>
      {u.limit_reached && (
        <p role="alert" className="text-sm text-red-800 font-semibold" data-testid="ai-spend-limit-reached">
          AI monthly limit reached. AI drafting is paused; everything else keeps working. {u.refused_calls} AI request(s) refused so far.
        </p>
      )}
      {Object.keys(u.warnings || {}).length > 0 && (
        <ul className="text-sm space-y-1" data-testid="ai-spend-warnings">
          {Object.entries(u.warnings).map(([lvl, at]) => <li key={lvl}>{lvl}% warning sent {new Date(at).toLocaleString()}</li>)}
        </ul>
      )}
      <p className="text-xs text-erf-dark/70" data-testid="ai-spend-note">{u.note}</p>
    </section>
  );
}
